/* eslint-disable import/no-cycle */
import React, { useEffect, useState, useContext, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { v1 as uuid } from 'uuid';
import { FilterType } from '../../../_shared/constants/filters';

import { FilterContext } from '../internal';

import {
  StyledConditionFilter,
  StyledCondition,
  Label,
  StyledToggle
} from './Styles';

const ConditionFilter = () => {
  const {
    filterMetaData: { conditions },
    updateFilter
  } = useContext(FilterContext);

  const [conditionAsIs, conditionAccident, conditionAmount] = conditions;

  const [conditionFilters, setConditionFilters] = useState([
    {
      label: 'list.filters.conditions.asIs',
      name: 'omitAsIs',
      isSelected: conditionAsIs?.isSelected,
      key: conditionAsIs?.key,
      displayName: conditionAsIs?.displayName,
      value: conditionAsIs?.displayName
    },
    {
      label: 'list.filters.conditions.any.history',
      name: 'omitHistory',
      isSelected: conditionAccident?.isSelected,
      key: conditionAccident?.key,
      displayName: conditionAccident?.displayName,
      value: conditionAccident?.displayName
    },
    {
      label: 'list.filters.conditions.accident.amount',
      name: 'omitAmount',
      isSelected: conditionAmount?.isSelected,
      key: conditionAmount?.key,
      displayName: conditionAmount?.displayName,
      value: conditionAmount?.displayName
    }
  ]);

  useEffect(() => {
    setConditionFilters(currState => {
      return currState.map((item, index) => {
        return {
          ...item,
          isSelected: conditions[index]?.isSelected,
          displayName: conditions[index]?.displayName,
          value: conditions[index]?.value,
          key: conditions[index]?.key
        };
      });
    });
  }, [conditions]);

  const handleToggle = useCallback(
    index => {
      let updatedConditions = [];

      updatedConditions = [
        ...conditionFilters.slice(0, index),
        {
          ...conditionFilters[index],
          isSelected: !conditionFilters[index].isSelected
        },
        ...conditionFilters.slice(index + 1)
      ];

      setConditionFilters(updatedConditions);
      updateFilter(updatedConditions, FilterType.Condition);
    },
    [conditionFilters, updateFilter]
  );

  return (
    <StyledConditionFilter>
      {conditionFilters.map((condition, index) => {
        return (
          <StyledCondition key={uuid()}>
            <Label>
              <FormattedMessage id={condition.label} />
            </Label>
            <StyledToggle
              isChecked={condition?.isSelected}
              onClick={() => handleToggle(index)}
              testId={`filter-${condition.name}`}
            />
          </StyledCondition>
        );
      })}
    </StyledConditionFilter>
  );
};

export default ConditionFilter;
